/* ==========================================================================
   GLOBAL NAVIGATION REDESIGN  (assets/global-nav.js)
   --------------------------------------------------------------------------
   Desktop only. Keeps aria-expanded on each .gnav__cat-link in sync with
   hover / focus-within (panels open via CSS), and closes any open panel
   when Escape is pressed. No mobile/drawer code here -- the theme's
   #mobile-menu drawer is driven by theme.js.
   Re-initialises on Shopify theme-editor section reloads.
   ========================================================================== */
(function () {
  "use strict";

  function init(root) {
    var cats = Array.prototype.slice.call(root.querySelectorAll("[data-gnav-cat]"));
    cats.forEach(function (cat) {
      var link = cat.querySelector(".gnav__cat-link");
      if (!link) return;

      function setExpanded(expanded) {
        link.setAttribute("aria-expanded", expanded ? "true" : "false");
      }

      cat.addEventListener("mouseenter", function () { setExpanded(true); });
      cat.addEventListener("mouseleave", function () { setExpanded(false); });
      cat.addEventListener("focusin", function () { setExpanded(true); });
      cat.addEventListener("focusout", function (e) {
        if (!cat.contains(e.relatedTarget)) setExpanded(false);
      });
    });
  }

  function initAll() {
    Array.prototype.slice.call(document.querySelectorAll("[data-gnav]")).forEach(init);
    initMobileFirstGroup();
  }

  // Mobile drawer: expand each category's first subsection the first time its
  // panel is opened. We trigger the theme's own accordion toggle (rather than
  // forcing it open in CSS) so it stays open-by-default AND fully collapsible.
  function initMobileFirstGroup() {
    var openers = document.querySelectorAll('#mobile-menu [data-action="open-panel"]');
    Array.prototype.slice.call(openers).forEach(function (btn) {
      if (btn.dataset.gnavBound) return;
      btn.dataset.gnavBound = "1";
      btn.addEventListener("click", function () {
        var panel = document.getElementById(btn.getAttribute("aria-controls"));
        if (!panel || panel.dataset.gnavFirstOpened) return;
        panel.dataset.gnavFirstOpened = "1";
        var item = panel.querySelector(".mobile-menu__nav-list > .mobile-menu__nav-list-item");
        var toggle = item && item.querySelector(".mobile-menu__nav-list-toggle");
        var coll = item && item.querySelector(".mobile-menu__nav-collapsible");
        if (!toggle || !coll) return;
        // Open it directly (don't rely on the theme measuring scrollHeight).
        // The theme's accordion still owns subsequent collapse/expand on tap.
        setTimeout(function () {
          if (toggle.getAttribute("aria-expanded") === "true") return;
          toggle.setAttribute("aria-expanded", "true");
          // match the theme's own format (explicit px) so its collapse animates cleanly
          coll.style.height = coll.scrollHeight + "px";
        }, 60);
      });
    });
  }

  // Escape closes any open mega-menu panel by blurring its focused descendant.
  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape" && e.keyCode !== 27) return;
    var active = document.activeElement;
    if (active && active.closest && active.closest("[data-gnav-cat]")) {
      active.blur();
    }
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }
  document.addEventListener("shopify:section:load", function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector("[data-gnav]")) {
      initAll();
    }
  });
})();
